/**
 * @flow
 * @relayHash e697408f0a2ff8c750f476aa68384e6c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type AddPurchaseOrderInput = {|
  vendorId: string,
  lineItems: $ReadOnlyArray<PurchaseOrderLineInput>,
  notes?: ?string,
  expectedDeliveryDate?: ?any,
|};
export type PurchaseOrderLineInput = {|
  itemId: string,
  quantity: number,
  unitPrice: number,
|};
export type AddPurchaseOrderMutationVariables = {|
  input: AddPurchaseOrderInput
|};
export type AddPurchaseOrderMutationResponse = {|
  +addPurchaseOrder: {|
    +purchaseOrderEdge: {|
      +node: {|
        +id: string,
        +poNumber: string,
        +vendor: ?{|
          +id: string,
          +vendorNumber: string,
          +name: string,
        |},
        +status: POStatus,
        +totalAmount: number,
        +expectedDeliveryDate: ?any,
        +notes: ?string,
        +requestedBy: ?{|
          +id: string,
          +firstName: string,
          +lastName: string,
        |},
        +createdAt: any,
        +updatedAt: any,
      |}
    |}
  |}
|};
export type AddPurchaseOrderMutation = {|
  variables: AddPurchaseOrderMutationVariables,
  response: AddPurchaseOrderMutationResponse,
|};
*/


/*
mutation AddPurchaseOrderMutation(
  $input: AddPurchaseOrderInput!
) {
  addPurchaseOrder(input: $input) {
    purchaseOrderEdge {
      node {
        id
        poNumber
        vendor {
          id
          vendorNumber
          name
        }
        status
        totalAmount
        expectedDeliveryDate
        notes
        requestedBy {
          id
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddPurchaseOrderInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addPurchaseOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddPurchaseOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "purchaseOrderEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrderEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchaseOrder",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "poNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Vendor",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "vendorNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expectedDeliveryDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "requestedBy",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddPurchaseOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddPurchaseOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddPurchaseOrderMutation",
    "id": null,
    "text": "mutation AddPurchaseOrderMutation(\n  $input: AddPurchaseOrderInput!\n) {\n  addPurchaseOrder(input: $input) {\n    purchaseOrderEdge {\n      node {\n        id\n        poNumber\n        vendor {\n          id\n          vendorNumber\n          name\n        }\n        status\n        totalAmount\n        expectedDeliveryDate\n        notes\n        requestedBy {\n          id\n          firstName\n          lastName\n        }\n        createdAt\n        updatedAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'be17609640f77a6eb14ec8972ace6dff';
module.exports = node;
